export default "__VITE_ASSET__BWOsI0j$__"